import styled from 'styled-components';

const InfoSubtitle = styled.div`
  color: ${props => props.theme.infoSubtitle}
  font-size: 14px;
  font-weight: 500;
`;

export default InfoSubtitle;
